;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('FormatListController', FormatListController)

  /* @ngInject */
  function FormatListController ($scope, $rootScope, ProductsService) {
    $scope.isSearching = false
    $scope.searchTerm = null
    $scope.filterType = null
    $scope.selected = null

    const api = {
      _successGetOwnerProducts,
      _successGetDefaultProducts,
      _successGetProducts,
      _defineFormatIcon,
      _doSearch,
      _handleOnChangeFormatType
    }

    this.getApi = () => api

    activate()

    function activate () {
      $scope.filterType = $scope.standardFilter
      if ($scope.standard) {
        ProductsService
          .getDefaultProducts($scope.filterType)
          .then(api._successGetDefaultProducts)
          .then(api._successGetProducts)
      } else {
        $scope.formatsTop = 16
        ProductsService
          .getAllProducts({ top: $scope.formatsTop, skip: 0, type: $scope.filterType })
          .then(api._successGetOwnerProducts)
          .then(api._successGetProducts)
      }
    }

    const deregisterFormatSearch = $rootScope.$on('format.search', (e, searchInfo) => {
      $scope.searchTerm = searchInfo.width + ' x ' + searchInfo.height
      $scope.filterType = searchInfo.filterType
      $scope.isSearching = true
      $('.format-type-dropdown').dropdown('set selected', searchInfo.filterType)

      $scope.skipPagingTo(0)
    })

    $scope.$on('$destroy', () => {
      deregisterFormatSearch()
    })

    $scope.selectFormatClick = function (item) {
      $scope.selected = item
      $scope.$emit('templates.change-selected-format', item)
    }

    $scope.skipPagingTo = function (index) {
      const params = { top: $scope.formatsTop, skip: $scope.formatsTop * index }

      if ($scope.isSearching && $scope.searchTerm) {
        params.search = $scope.searchTerm
      }

      if ($scope.filterType) {
        params.type = $scope.filterType
      }

      ProductsService.getAllProducts(params).then(api._successGetOwnerProducts)
    }

    $scope.clearSearch = function () {
      $scope.isSearching = false
      $scope.searchTerm = null
      if ($scope.standard) {
        ProductsService.getDefaultProducts($scope.filterType).then(api._successGetDefaultProducts)
      } else {
        ProductsService.getAllProducts({ top: $scope.formatsTop, skip: 0, type: $scope.filterType }).then(api._successGetOwnerProducts)
      }
    }

    $scope.onSeachKeydown = function ($event) {
      if ($event.keyCode === 13) {
        api._doSearch()
      }
    }

    function _doSearch () {
      $scope.isSearching = true
      if ($scope.standard) {
        ProductsService.getDefaultProducts($scope.filterType, $scope.searchTerm).then(api._successGetDefaultProducts)
      } else {
        ProductsService.getAllProducts({
          top: $scope.formatsTop,
          skip: 0,
          search: $scope.searchTerm,
          type: $scope.filterType
        }).then(api._successGetOwnerProducts)
      }
    }

    function _successGetOwnerProducts (res) {
      $scope.formats = res.d.results
      $scope.formatsCount = res.d.__count

      $scope.formats.forEach(format => {
        format.texts = format.product_texts.find(item => item.locale === $rootScope.oUser.locale)
        if (!format.slug) {
          format.slug = 'default'
        }
        api._defineFormatIcon(format)
      })
    }

    function _successGetDefaultProducts (data) {
      $scope.formats = []
      $scope.formatsCount = 0

      data.d.results.forEach(product => {
        product.texts = product.product_texts.find(item => item.locale === $rootScope.oUser.locale)
        api._defineFormatIcon(product)
        $scope.formats.push(product)
        $scope.formatsCount++
      })
    }

    function _defineFormatIcon (format) {
      const width = format.width || format.originalWidth || (format.layers && format.layers[0].width)
      const height = format.height || format.originalHeight || (format.layers && format.layers[0].height)

      if (format.customerSpecific && format.customerCompanyId) {
        if (format.rounded) {
          format.icon = 'format-circle-custom'
        } else if (width === height) {
          format.icon = 'format-square-custom'
        } else if (width > height) {
          format.icon = 'format-long-custom'
        } else {
          format.icon = 'format-tall-custom'
        }
      } else {
        if (format.rounded) {
          format.icon = 'format-circle-default'
        } else if (width === height) {
          format.icon = 'format-square-default'
        } else if (width > height) {
          format.icon = 'format-long-default'
        } else {
          format.icon = 'format-tall-default'
        }
      }
    }

    function _handleOnChangeFormatType (type) {
      $scope.filterType = type
      api._doSearch()
    }

    function _successGetProducts () {
      $('.format-list-directive .format-type-dropdown').dropdown({
        clearable: true,
        onChange: api._handleOnChangeFormatType
      })
      if ($scope.onLoad) {
        $scope.onLoad({
          $event: $scope.formats
        })
      }
    }
  }
})()
